/* eslint-disable code-style/no-hardcoded-strings */

import { styled, Typography } from "@mui/material";

export const StyledStatusLabel = styled(
    Typography,
    { shouldForwardProp: (prop) => prop !== "statusType" },
)(({
    statusType,
    theme,
}) => ({
    background: statusType ? theme.palette.success.light : theme.palette.error.light,
    borderRadius: theme.shape.borderRadius,
    color: statusType ? theme.palette.success.dark : theme.palette.error.dark,
    display: "inline-block",
    fontWeight: "bold",
    height: "32px",
    minWidth: "37px",
    padding: "8px 16px",
    width: "fit-content",
}));
